module.exports = __webpack_public_path__ + "static/4727a330.BrazilBannerRight.png";